import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { createPortal } from '../services/subscriptionApi';

const SubscriptionBanner = () => {
  const { user, subscription } = useAuth();

  if (!user || user.is_admin || !subscription) return null;

  const handlePortal = async () => {
    try {
      const res = await createPortal();
      window.location.href = res.data.url;
    } catch { /* ignore */ }
  };

  // Calculate days remaining for trial
  if (subscription.status === 'trialing' && subscription.trial_ends_at) {
    const daysLeft = Math.max(0, Math.ceil((new Date(subscription.trial_ends_at) - new Date()) / 86400000));
    if (daysLeft <= 0) return null; // Gate will handle expired trial
    return (
      <div className="bg-amber-500/10 border-b border-amber-500/20 px-4 py-2 text-center text-sm text-amber-400">
        Essai gratuit — {daysLeft} jour{daysLeft > 1 ? 's' : ''} restant{daysLeft > 1 ? 's' : ''}
      </div>
    );
  }

  // Cancellation pending
  if (subscription.status === 'active' && subscription.cancel_at_period_end) {
    const endDate = subscription.current_period_end
      ? new Date(subscription.current_period_end).toLocaleDateString('fr-FR')
      : '—';
    return (
      <div className="bg-orange-500/10 border-b border-orange-500/20 px-4 py-2 text-center text-sm text-orange-400">
        Votre abonnement se termine le {endDate}
      </div>
    );
  }

  // Past due
  if (subscription.status === 'past_due') {
    return (
      <div className="bg-red-500/10 border-b border-red-500/20 px-4 py-2 text-center text-sm text-red-400">
        Paiement échoué —{' '}
        <button onClick={handlePortal} className="underline hover:text-red-300 transition-colors">
          Mettre à jour vos informations de paiement
        </button>
      </div>
    );
  }

  return null;
};

export default SubscriptionBanner;
